import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import usePostAxiosData from "hooks/usePostAxiosData";
import toast from "react-hot-toast";
import Error from "components/message/Error";
import { AppBar, Dialog, DialogContent, Toolbar, Typography } from "@mui/material";
import MButton from "components/Mbutton";
import { CloseModalButton } from "components/Utils";
import MuiAsyncAutocomplete from "components/MuiAsyncAutocomplete";
import { useTranslation } from "react-i18next";

const AddTaskEnterprise = (props) => {
  const { isOpen, onClose, task } = props;
  const { t } = useTranslation("add_task_enterprise");

  /** Form validation config */
  const schema = yup.object().shape({});

  const [selectedEnterprise, setSelectedEnterprise] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });


  const onSubmitHandler = (data) => {
    handleSave(data);
  };

  /** post create user */
  const [loading, postAxiosData, errorMassage, successMessage, result] =
    usePostAxiosData(`tasks/${task?.id}/add-enterprise`, "POST");

  const handleSave = async (dataYub) => {
    const data = Array.of(selectedEnterprise?.value);

    console.log("🚀 ~ handleSave ~ data:", data);

    await postAxiosData(data);
  };

  /** gestion des erreurs et succès */
  useEffect(() => {
    if (successMessage?.status === 200 || successMessage?.status === 201) {
      reset();
      toast.success(
        `${successMessage?.message != null
          ? successMessage?.message
          : t("default_success_message") // Traduit
        }`,
        {
          duration: 4000,
          className: "bg-success text-white",
        }
      );
      props?.endFetch();
      setSelectedEnterprise(null);
      onClose(); // Fermer la modale après succès
    }
  }, [successMessage, reset, props, onClose, t]); // Ajouter 't' aux dépendances

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar className="bg-gray-50">
            <Typography sx={{ ml: 2, flex: 1 }} color={'green'} fontWeight={'bold'} variant="h6" component="div" >
              {t("assign_enterprise_title")} {task?.description} {/* Traduit */}
            </Typography>
            <CloseModalButton iconColor={'red'} handleClose={onClose} />
          </Toolbar>
        </AppBar>

        <DialogContent dividers>
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <div className="my-4 grid gap-2 md:grid-cols-1">
              {errorMassage?.message && (
                <Error
                  message={
                    errorMassage?.message !== "" && errorMassage?.message
                  }
                />
              )}

              <MuiAsyncAutocomplete
                label={t("enterprises_label")}
                value={selectedEnterprise}
                format={{ value: 'id', label: 'socialRaison' }}
                fetch={'enterprises/search-all-by-term'}
                handleChange={(e, item) => {
                  console.log("🚀 ~ AddTaskEnterprise ~ item:", item);
                  setSelectedEnterprise(item);
                }}
                wrapperClasses={"flex-1 filter-item anime slideRight"}
              />
            </div>
            <div className="flex justify-between p-4">
              <div>
                <MButton
                  variant={"danger"}
                  onClick={(e) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    onClose();
                  }}
                >
                  {t("close_button")} {/* Traduit */}
                </MButton>
              </div>
              <div>
                <MButton variant={"primary"} type="submit" colorScheme="green">
                  {t("assign_button")} {/* Traduit */}
                </MButton>
              </div>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddTaskEnterprise;